module.exports = __webpack_public_path__ + "static/q14_x-a0b146f4cc09b2f44d21bf83bc69f91e.png";